import React, { useState, useEffect } from "react";
import Ticket from "./Ticket";
import FilterTickets from "./FilterTickets";
import Loading from "../../../../../components/Loading";
import _ from "lodash";
import { checkIfFreeTicketAndReferral, errorToaster } from "../../../../../helpers/utils";
import moment from "moment";
import { categorizeTickets, filterObjectsById } from "../../../../../helpers/common";

const PickTickets = ({
	ticketDetails,
	query,
	onTicketSelect,
	onProceed,
	isWidget,
	isLoading,
	pickedTickets,
	couponCodeLimit,
	initialMount,
	eventDetails,
	accessCodeStatus,
	triggeredOnce,
	teamRegType,
	accessCodeTriggered,
	couponLoading,
	groupDiscounts,
	setInitialMount
}) => {
	const [selectedTickets, setSelectedTickets] = useState([]);
	const [tickets, setTickets] = useState([]);
	const [remainingCoupons, setRemainingCoupons] = useState(null);
	const [componentDidMount, setComponentDidMount] = useState(false);
	const [filterVal, setFilterVal] = useState(null);
	const [donationEnabled, setDonationEnabled] = useState(true);
	const [accordionState, setAccordionState] = useState({});

	const ticketDate = (ticket, eventDetails, type) => {
		// This is to validate if the selected ticket (via query param) is expired or in common state
		var todaysDate = moment().valueOf();
		// convert utc to local
		let ticketStartDate = moment.utc(`${ticket.start_timestamp}`).local().valueOf();
		let ticketEndDate = moment.utc(`${ticket.end_timestamp}`).local().valueOf();
		let eventEndDate = moment
			.utc(`${eventDetails.end_date} ${eventDetails.end_time}`)
			.local()
			.valueOf();
		if (type === "isExpired" && (todaysDate > ticketEndDate || todaysDate > eventEndDate))
			return true;
		if (type === "isComingSoon" && ticketStartDate > todaysDate) return true;
		else return false;
	};

	useEffect(() => {
		if (!componentDidMount) {
			setComponentDidMount(true);
		} else if (couponCodeLimit && componentDidMount) {
			initializeCouponCode(couponCodeLimit, accessCodeStatus, ticketDetails);
		}
		if (couponCodeLimit === null && accessCodeStatus !== 1 && accessCodeTriggered.current) {
			accessCodeTriggered.current = false;
			setSelectedTickets([]);
		}
	}, [couponCodeLimit, ticketDetails, componentDidMount]);

	//Initial useEffect - (Refer readMe.md for more info)
	useEffect(() => {
		if (ticketDetails.length !== 0) {
			let allTickets = ticketDetails.sort((a, b) => {
				// Sort the forms by from order
				return a.ticket_order - b.ticket_order;
			});

			if (teamRegType !== false) {
				if (teamRegType === 0)
					allTickets = allTickets.filter(ticket => ticket.team_registration === false);
				else allTickets = allTickets.filter(ticket => ticket.team_registration === true);
			}


			allTickets.forEach((ticket) => {
				if (isWidget) {
					const pickedTicket = pickedTickets.find(picked => picked.ticket_id === ticket.ticket_id);
					ticket.totalSelected = pickedTicket?.totalSelected ?? 0;
				} else {
					if (!ticket?.totalSelected && _.isEmpty(pickedTickets)) {
						ticket.totalSelected = 0;
					}
				}
			})

			const ticketUpdates = query?.ticketId?.split(';')?.map(item => {
				const [id, total] = item?.split('|');
				return { ticket_id: parseInt(id), totalSelected: parseInt(total) };
			});

			if (query?.ticketId?.includes("|") && ticketUpdates?.length > 0 && initialMount) {
				ticketUpdates?.forEach(({ ticket_id, totalSelected }) => {
					const index = allTickets.findIndex(ticket => ticket?.ticket_id === ticket_id);
					if (index !== -1) {
						const isSoldOut = allTickets[index].sold_out || allTickets[index].remaining_count <= 0;
						const isExpired = ticketDate(allTickets[index], eventDetails, "isExpired");
						const isComingSoon = ticketDate(
							allTickets[index],
							eventDetails,
							"isComingSoon"
						);
						const isWaitlist = allTickets[index].waitlist_enabled && isSoldOut;
						const isFreeRefferal = checkIfFreeTicketAndReferral(query, allTickets[index]);
						const isApproval = allTickets[index].approval_enabled;
						if (allTickets[index].ticket_type !== 3) {
							if (isWaitlist || isFreeRefferal || (isApproval && !isSoldOut)) {
								allTickets[index].totalSelected = 1;
							} else if (isSoldOut || isExpired || isComingSoon) {
								return;
							} else {
								allTickets[index].totalSelected = totalSelected;
							}
						} else {
							if (isSoldOut || isExpired || isComingSoon) {
								return;
							}
							setDonationEnabled(false);
							allTickets[index].donationAmountEnabled = true;
						}
					}
				});
				setSelectedTickets(allTickets.filter(each => each.totalSelected > 0));
			} else if (query.ticketId && initialMount) {
				const index = allTickets.findIndex(
					ticket => ticket.ticket_id === parseInt(query.ticketId)
				);
				if (index > -1) {
					const isSoldOut =
						allTickets[index].sold_out || allTickets[index].remaining_count <= 0;
					const isExpired = ticketDate(allTickets[index], eventDetails, "isExpired");
					const isComingSoon = ticketDate(
						allTickets[index],
						eventDetails,
						"isComingSoon"
					);
					const isWaitlist = allTickets[index].waitlist_enabled && isSoldOut;
					const isFreeRefferal = checkIfFreeTicketAndReferral(query, allTickets[index]);
					const isApproval = allTickets[index].approval_enabled;
					if (allTickets[index].ticket_type !== 3) {
						if (isWaitlist || isFreeRefferal || (isApproval && !isSoldOut)) {
							allTickets[index].totalSelected = 1;
							setSelectedTickets([allTickets[index]]);

						} else if (isSoldOut || isExpired || isComingSoon) {
							return;
						} else {
							if (isWidget) {
								const updatedTicket = { ...allTickets[index] };
								updatedTicket.totalSelected = updatedTicket.min_tickets;
								allTickets[index].totalSelected = updatedTicket;
								setTickets([...allTickets]);
								setSelectedTickets([updatedTicket]);
							} else {
								allTickets[index].totalSelected = allTickets[index].min_tickets;
								setSelectedTickets([allTickets[index]]);
							}
						}
					} else {
						if (isSoldOut || isExpired || isComingSoon) {
							return;
						}
						setDonationEnabled(false);
						allTickets[index].donationAmountEnabled = true;
					}
				}
			}

			if (accessCodeStatus === 1) {
				//If access code is applied (when user applied access code from event page)
				accessCodeTriggered.current = true;
				if (query?.ticketId?.includes("|") && ticketUpdates?.length > 0 && !triggeredOnce.current) {
					//when more than single ticket is selected via ticket url coming from query
					// biome-ignore lint/complexity/noForEach: <explanation>
					ticketUpdates?.forEach(({ ticket_id, totalSelected }) => {
						const index = allTickets.findIndex(ticket => ticket?.ticket_id === ticket_id);
						if (index !== -1) {
							triggeredOnce.current = true;
							allTickets[index].totalSelected = totalSelected;
						}
					});
					setSelectedTickets(allTickets.filter(each => each.totalSelected > 0));
				} else
					if (!(query?.ticketId?.includes("|")) && query.ticketId && query.selectedCode && !triggeredOnce.current) {
						const index = allTickets.findIndex(
							ticket => ticket.ticket_id === parseInt(query.ticketId)
						);
						if (index > -1) {
							if (allTickets[index].ticket_type !== 3) {
								triggeredOnce.current = true;
								allTickets[index].totalSelected = 1;
								setSelectedTickets([allTickets[index]]);
							} else allTickets[index].donationAmountEnabled = true;
						}
					}
			}

			setTickets(allTickets);
			setInitialMount(false);
		} else {
			setTickets([]);
		};
	}, [ticketDetails, pickedTickets, initialMount]);
	//Waitlist useEffect - If clicked on a waitlist or approval or a Free Referral ticket, directly proceed (Refer readMe.md for more info)
	useEffect(() => {
		if (!_.isEmpty(selectedTickets)) {
			let isWaitlist = false;
			let isApproval = false;
			let isFreeRefferal = false;
			selectedTickets.forEach(ticket => {
				if (
					(ticket.waitlist_enabled && ticket.sold_out) ||
					(ticket.waitlist_enabled && ticket.remaining_count <= 0)
				) {
					isWaitlist = true;
				} else if (checkIfFreeTicketAndReferral(query, ticket)) {
					isFreeRefferal = true;
				}
				if (ticket.approval_enabled && !ticket.sold_out) {
					isApproval = true;
				}
			});
			if (isWaitlist || isFreeRefferal || isApproval) onProceed(selectedTickets, isApproval);
		}
	}, [selectedTickets, query]);

	useEffect(() => {
		onTicketSelect(selectedTickets);
	}, [selectedTickets]);

	// pickedTicket useEffect - (Refer readMe.md for more info)
	useEffect(() => {
		//This runs if the user comes back from attendee details
		if (!_.isEmpty(pickedTickets)) {
			let isWaitlist = false;
			let isApproval = false;
			let isFreeRefferal = false;
			pickedTickets.forEach((ticket, i) => {
				if (
					ticket.waitlist_enabled ||
					ticket.approval_enabled ||
					checkIfFreeTicketAndReferral(query, ticket)
				) {
					if (
						(ticket.waitlist_enabled && ticket.sold_out) ||
						(ticket.remaining_count <= 0 && ticket.waitlist_enabled)
					)
						isWaitlist = true;
					else if (checkIfFreeTicketAndReferral(query, ticket)) isFreeRefferal = true;
					else if (ticket.approval_enabled) isApproval = true;
					ticket.totalSelected = 0;
				}
			});
			if (!isWaitlist && !isFreeRefferal && !isApproval) setSelectedTickets(pickedTickets);
		}
	}, []);

	const couponCodeCheck = (type, ticketsCount) => {
		// Check if the coupon code is remaining
		let couponsLeft;
		if (type === "add") {
			couponsLeft = remainingCoupons - ticketsCount;
			if (couponsLeft < 0) {
				return true;
			} else {
				setRemainingCoupons(couponsLeft);
				return false;
			}
		} else if (type === "remove") {
			couponsLeft = remainingCoupons + ticketsCount;
			setRemainingCoupons(couponsLeft);
		}
	};

	const initializeCouponCode = (couponCodeLimit, accessCodeStatus = false, ticketDetails) => {
		//Runs after adding the coupon code
		let allTickets = _.isEmpty(pickedTickets)
			? filterObjectsById(ticketDetails, selectedTickets)
			: filterObjectsById(ticketDetails, pickedTickets);
		let totalTicketSelected = 0; //To store how many discount tickets have already been selected
		allTickets.forEach((ticket, i) => {
			if (ticket.discount) {
				totalTicketSelected += ticket.totalSelected;
			}
		});
		if (totalTicketSelected > couponCodeLimit) {
			//If the selected amount of tickets is higher than the code limit
			let newTickets = allTickets.map(ticket => {
				if (ticket.discount) {
					ticket.totalSelected = 0;
				}
				return ticket;
			});
			errorToaster(
				`You have selected more tickets than the coupon code remaining, please select the tickets again.`
			);
			setSelectedTickets(newTickets);
			setRemainingCoupons(couponCodeLimit);
		} else if (!_.isEmpty(pickedTickets) && accessCodeStatus == 1) {
			//After the access code applied at first
			setSelectedTickets([]);
			setRemainingCoupons(couponCodeLimit - totalTicketSelected);
		} else {
			setSelectedTickets(allTickets);
			setRemainingCoupons(couponCodeLimit - totalTicketSelected); // minus the already selected tickets from the coupon code limit
		}
	};

	const updateSelectedTicket = addedTicket => {
		let tickets = [...selectedTickets];
		let donationEnabled = true;
		if (tickets.length > 0) {
			const duplicateTicket = tickets.filter(
				ticket => ticket.ticket_id === addedTicket.ticket_id
			);
			//If already the same ticket has been selected once
			if (duplicateTicket.length > 0) {
				const index = tickets.findIndex(
					ticket => ticket.ticket_id === addedTicket.ticket_id
				);
				tickets[index] = addedTicket;
				setSelectedTickets(tickets);
			} else {
				tickets.push(addedTicket);
				setSelectedTickets(tickets);
			}
		} else {
			tickets.push(addedTicket);
			setSelectedTickets(tickets);
		}

		const ticketCategory = categorizeTickets(tickets).categorized.find(
			(category) =>
				category.tickets.some(
					(ticket) => ticket.ticket_id === addedTicket.ticket_id,
				),
		);
		if (ticketCategory) {
			setAccordionState((prevState) => ({
				...prevState,
				[ticketCategory.category_id]: true,
			}));
		}
	};

	const removeTicket = removedTicket => {
		let tickets = [...selectedTickets];
		const index = tickets.findIndex(
			(ticket) => ticket.ticket_id === removedTicket.ticket_id,
		);
		tickets.splice(index, 1);
		setSelectedTickets(tickets);

		// Keep the accordion open even when the ticket is removed
		const ticketCategory = categorizeTickets(tickets).categorized.find(
			(category) =>
				category.tickets.some(
					(ticket) => ticket.ticket_id === removedTicket.ticket_id,
				),
		);
		if (ticketCategory) {
			setAccordionState((prevState) => ({
				...prevState,
				[ticketCategory.category_id]: true,
			}));
		}
	};

	const clearTickets = () => {
		let allTickets = tickets;
		allTickets.forEach((ticket) => (ticket.totalSelected = 0));
		setSelectedTickets([]);
		setTickets(allTickets);
	};

	const toggleAccordion = (category_id) => {
		setAccordionState((prevState) => ({
			...prevState,
			[category_id]: !prevState[category_id],
		}));
	};

	useEffect(() => {
		const initialAccordionState = {};
		const categorizedTickets = categorizeTickets(tickets).categorized;
		categorizedTickets.forEach((category) => {
			if (category.is_expanded) {
				initialAccordionState[category.category_id] = true;
			}
		});
		selectedTickets.forEach((selectedTicket) => {
			const ticketCategory = categorizedTickets.find((category) =>
				category.tickets.some(
					(ticket) => ticket.ticket_id === selectedTicket.ticket_id,
				),
			);
			if (ticketCategory) {
				initialAccordionState[ticketCategory.category_id] = true;
			}
		});
		setAccordionState(initialAccordionState);
	}, [selectedTickets, tickets]);

	return (
		tickets != null && (
			<div className="h-100 scroll w-100 position-relative container-bg">
				{/* Filtering the tickets if there are more than 6 */}
				{ticketDetails.length > 6 ? (
					<FilterTickets
						setFilterVal={setFilterVal}
						filterVal={filterVal}
						setTickets={setTickets}
						tickets={tickets}
						ticketDetails={ticketDetails}
					/>
				) : (
					""
				)}
				{/* All Tickets */}

				<div className="h-100 container-fluid pt-4 pb-1 pb-md-5 mb-md-2">
					<div className="row">
						{categorizeTickets(tickets).uncategorized.length !== 0 ? (
							categorizeTickets(tickets).uncategorized.map((ticketInfo, i) => (
								<div
									key={`${i}-ticket`}
									className={`col-12 col-md-12 ${isWidget ? "" : "col-lg-12"
										} mb-4`}
								>
									<Ticket
										key={`${i}-ticket`}
										groupDiscounts={groupDiscounts}
										ticketInfo={ticketInfo}
										selectedTickets={selectedTickets}
										updateSelectedTicket={updateSelectedTicket}
										removeTicket={removeTicket}
										couponCodeCheck={couponCodeCheck}
										eventDetails={eventDetails}
										query={query}
										isWidget={isWidget}
										donationEnabled={donationEnabled}
										setDonationEnabled={setDonationEnabled}
										teamRegType={teamRegType}
									/>
								</div>
							))
						) : isLoading ||
							(couponLoading && categorizeTickets(tickets).categorized.length === 0) ? (
							<div className="h-100">
								<Loading className="text-center my-1 py-1" />
							</div>
						) : categorizeTickets(tickets).categorized.length === 0 ? (
							<div className="h-100 text-center">No tickets available</div>
						) : (
							""
						)}
						{categorizeTickets(tickets).categorized.length > 0 && (
							<div className="">
								{categorizeTickets(tickets).categorized.map(
									(category) => (
										<div
											key={category.category_id}
											className="accordion mb-4"
											id={`accordian-${category.category_id}`}
										>
											{category.tickets.length > 0 && (
												<div className="category-box accordion-item">
													<h2
														className="accordion-header"
														id={`heading-${category.category_id}`}
														style={{ marginBottom: "0px" }}
													>
														<button
															className={`accordion-button ${accordionState[category.category_id] ? "" : "collapsed"}`}
															type="button"
															data-bs-toggle="collapse"
															data-bs-target={`#collapse-${category.category_id}`}
															aria-expanded={accordionState[category.category_id] || false}
															aria-controls={`collapse-${category.category_id}`}
															onClick={() =>
																toggleAccordion(category.category_id)
															}
														>
															{category.category_name}
															<span className="accordion-arrow ms-2"></span>
														</button>
													</h2>
													<div
														id={`collapse-${category.category_id}`}
														className={`accordion-collapse collapse ${accordionState[category.category_id] ? "show" : ""}`}
														aria-labelledby={`heading-${category.category_id}`}
														data-bs-parent={`#accordian-${category.category_id}`}
													>
														{" "}
														{category.category_description && (
															<div
																className="accordion-body"
																dangerouslySetInnerHTML={{
																	__html: category.category_description
																}}
															/>
														)}
														<div className="tickets accordion-body">
															{category.tickets.map(
																(ticketInfo, i) => (
																	<div
																		className={
																			i > 0 ? `mt-3` : ""
																		}
																	>
																		<Ticket
																			key={`${i}-ticket`}
																			groupDiscounts={groupDiscounts}
																			ticketInfo={ticketInfo}
																			selectedTickets={
																				selectedTickets
																			}
																			updateSelectedTicket={
																				updateSelectedTicket
																			}
																			removeTicket={
																				removeTicket
																			}
																			couponCodeCheck={
																				couponCodeCheck
																			}
																			eventDetails={
																				eventDetails
																			}
																			query={query}
																			isWidget={isWidget}
																			donationEnabled={
																				donationEnabled
																			}
																			setDonationEnabled={
																				setDonationEnabled
																			}
																			teamRegType={
																				teamRegType
																			}
																		/>
																	</div>
																)
															)}
														</div>
													</div>
												</div>
											)}
										</div>
									)
								)}
							</div>
						)}
						<div className="mt-md-5"></div>
					</div>
				</div>
				<style jsx global>{`
        .proceed-btn-container {
          position: sticky;
          min-height: 75px;
          bottom: -1px;
          color: ${query.btnContCl ? `#${query.btnContCl}` : "#000000"};
          background: ${query.btnContBg ? `#${query.btnContBg}` : "#ffeeed"};
          animation: ${selectedTickets.length > 0 ? "slideUp" : "slideDown"};
            0.3s forwards;
          -webkit-animation: ${selectedTickets.length > 0 ? "slideUp" : "slideDown"}
            0.3s forwards; /* for less modern browsers */
        }
        .btn-height {
          height: 42px;
          line-height: 1rem;
        }

        .category-box {
            border-radius: 10px !important;
            border: 2px solid #EFE9ED;
            background: #FFF;
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
        }

        .accordion-body {
            padding: 15px;
        }

        .accordion-button {
          font-size: 16px;
          font-weight: 500;
          border-radius: 10px !important;
        }

        .accordion-button:not(.collapsed) {
            background-color: #FFF;
            color: #212529;
            box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);
          }

        // .proceed-btn {
        //   color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
        //   background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        // }

        // .proceed-btn:hover {
        //   color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
        // }

        // .proceed-outline-btn {
        //   background: transparent;
        //   border-radius: 5px;
        //   font-size: 18px;
        //   font-weight: 500;
        //   padding: 10px 30px;
        //   transition: 0.2s all;
        //   color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        //   border: 1px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        // }

        // .proceed-outline-btn:hover {
        //   color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
        //   background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
        // }

        @media (max-width: 768px) {
          .proceed-btn-container {
            position: fixed !important;
            bottom: ${isWidget ? "0px" : "60px"};
            left: 0;
            border-radius: 0px;
          }
          .proceed-btns {
            width: auto;
          }
        }

        @media (max-width: 386px) {
          .proceed-btn-container {
            bottom: ${isWidget ? "0px" : "80px"};
          }
        }

        //for scroller
        ::-webkit-scrollbar {
          width: 5px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          background: transparent;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 30px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
      `}</style>
			</div>
		)
	);
};

export default PickTickets;